import React,{useState,useEffect} from 'react';
import Parosidebar from '../Components/Parosidebar';
import Paronavbar from '../Components/Paronavbar';
import ParodashboardMain from '../Components/ParodashboardMain';
import { Link } from 'react-router-dom';
import logout from '../Assets/Images/logout.png'
import { BASE_URL } from '../Config/Base';

function Paropdashboard() {
    const [sidebar, setSidebarOpen]=useState(false);
    const togglesidebar = ()=> {
        setSidebarOpen((prevState) => !prevState);
      }


      const token = JSON.parse(localStorage.getItem('usertoken'));

      useEffect(()=>{
        const venture = localStorage.getItem('ventureid');

      let PAROcheck = venture.includes('02')
     
   

  
  if(PAROcheck==true){
    document.getElementById("Paro-dashboard").style.display="grid"
  }
  else{
    document.getElementById("Paro-dashboard").style.display="none"
  
}
     
      Getusers()
      getParorole()
      GetAssignusers()
     },[]);


      /*---Once logout then clear localstorage function----*/

    function removelocalstorage(){
      localStorage.clear()
      window.location.href='/'

    }


    /*----Logout form function----*/

  function ToggleLogform()
   {
      document.getElementById("modalLogoutForm").style.display = "block";
   }
   
   
    
   function closeForm()
   {
      document.getElementById("modalLogoutForm").style.display = "none";
    
    }
   
    function Getusers(){
      console.log("Token",token)
      fetch(`${BASE_URL}/Paropakari/GetParoUsers`, {
       
      method:'GET',
    
        headers : {
    
          "Content-type": "application/json",
    
          "Accept": "application/json",
    
          "Authorization": "Bearer " + `${token}`,
    
          "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
        },
    
        //body:JSON.stringify(data)
    
      }).then(response => response.json())
      .then(data => {
        console.log("Data",data)
       
        localStorage.setItem("Paro-UsersData", JSON.stringify(data));
      });
    
    
    }


    /*---Get Roles ----*/

function getParorole(){


  fetch(`${BASE_URL}/Paropakari/GetParoAddRole`, {
    method:'GET',

  headers : {

    "Content-type": "application/json",

    "Accept": "application/json",

    "Authorization": "Bearer " +`${token}`,

    "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
  },


})

.then(response => response.json())


.then(data => {
console.log("Section",data)


localStorage.setItem("Data", JSON.stringify(data));
});

}

function GetAssignusers(){
  console.log("Token",token)

    fetch('https://localhost:44312/Api/Paropakari/GetParoAssignUser',{

      method:"GET",
      headers:{
        "Content-type": "application/json",

        "Accept": "application/json",
  
        "Authorization": "Bearer " + `${token}`,
  
        "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
      },
         //body:JSON.stringify(data)

    }).then(response=> response.json())
    .then(data=>{
      console.log("Data",data)
      
      localStorage.setItem("Paro-assignusers", JSON.stringify(data));
    });
  
  }
 
  
    return (
      <div className='parop-container' id="Paro-dashboard">
      <Paronavbar sidebar={sidebar} openSidebar={togglesidebar}/>
      <Parosidebar sidebar={sidebar} openLogForm={ToggleLogform}  />
      <ParodashboardMain/>

      <div className="Paropop-fade" id="modalLogoutForm" tabindex="-1" role="dialog">
  <div className="modal-dialog" role="document" id="Parologcenterform">
    <div className="modal-content">
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">LOG OUT</h4>
        <button type="button" className="close" onClick={closeForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

<form id='form'>

   <div className="modal-body mx-3">

        <div className="md-form mb-5">
            <div className='text-center'>
            <h5 id="Parodellog" ><img src={logout} id="causeimg"></img><br></br>Are you sure want to Logout?</h5>
          </div>
        </div>

   </div>

      <div className="modal-footer d-flex justify-content-center">
        <Link to="/"><button className="Paro-delete-button" onClick={removelocalstorage} type='submit'>Confirm</button></Link>
        <button className="Paro-delete-button" onClick={closeForm} type='submit'>Cancel</button>
      </div>

      </form>
      
    </div>
  </div>
</div>

    </div>
    );
}

export default Paropdashboard;